module.exports = __webpack_public_path__ + "static/media/audiology-associates.5ae700e7.png";